import { FC } from 'react'

import { Box, Spacer } from '@chakra-ui/react'
import { patchSettings } from '@editor/pages/projects/inspection-sheet/store'
import { RootState, useAppDispatch } from '@editor/store/app'
import { InspectionSheetSettings } from '@infraloop/common'
import { useSelector } from 'react-redux'
import { Link } from 'react-router'

const SettingsDrawerData: FC = () => {
  // Stores
  const dispatch = useAppDispatch()
  const settings = useSelector((state: RootState) => state.inspectionSheet.settings)

  return (
    <>
      <Box borderLeft="4px solid {colors.blue.400}" pl={2}>
        設定は工事全体に適用されます。 <br />
        初期設定を変更するには{' '}
        <Link to="/user#inspection-sheet" target="_blank">
          アカウント設定
        </Link>
        をご覧ください。
      </Box>

      <Spacer my={6} />

      <InspectionSheetSettings settings={settings} onChange={(newSettings) => dispatch(patchSettings(newSettings))} />
    </>
  )
}

export default SettingsDrawerData
